import request from '../../axios';

export const getNearestLabs = async (params: INearestLabParams) => {
  const cleanedParams = Object.fromEntries(
    Object.entries(params).filter(
      ([_, value]) =>
        value !== undefined &&
        value !== null &&
        value !== '' &&
        (!Array.isArray(value) || value.length > 0),
    ),
  );

  // serializing the query string to convert array payload to list params with format of param1=5222&param2=5412&param3=6661
  const serializedQueryString = Object.entries(cleanedParams)
    .flatMap(([key, value]) =>
      Array.isArray(value)
        ? value.map(
            item => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`,
          )
        : `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    )
    .join('&');

  const data: {data: INearestLabs} = await request.get(
    `api/v2/store/lab-list?${serializedQueryString}`,
  );

  return data;
};
